import template from './reorder-products-list.html';
export var ReorderProductsListComponent = {
    template: template,
    controller: /** @class */ (function () {
        /*@ngInject*/
        function ReorderProductsListComponent($state, $scope, $rootScope, $mdDialog, ReorderProductsService, $log, $q, CartService, SettingsService, CreditCardService, AddressService, AddressListService, Auth, CommonDataService, ProductService, googleAnalytic, $window, $location, $anchorScroll, $timeout, $cacheFactory, seoMetaService) {
            this.scrollPageCacheTag = 'reorder-page';
            this.scrollPositionCacheKey = 'reorder-page-scroll-position';
            this.pageSettingsCacheKey = 'reorder-page-search-settings';
            this.sortType = 'orderDate'; // set the default sort type
            this.sortReverse = false; // set the default sort order
            this.searchProduct = ''; // set the default search/filter term
            this.isLoading = false;
            this.blockCheckOut = false;
            this.products = [];
            this.errors = {};
            this.alternateSizes = [];
            this.alternateProducts = [];
            this.selectedProduct = {};
            this.isSettingsLoadedFromCache = false;
            // set the default amount of items being displayed
            this.showViewMore = false;
            // set the default amount of items being displayed
            this.limit = 0; // maxsim allowed product
            this.busyLoad = false;
            this.isLoggedIn = function () {
                if (this.loggedInUser) {
                    return true;
                }
                return false;
            };
            var self = this;
            this.$log = $log;
            this.ga = googleAnalytic;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$mdDialog = $mdDialog;
            this.$state = $state;
            this.Auth = Auth;
            this.$q = $q;
            this.reorderProductsService = ReorderProductsService;
            this.CartService = CartService;
            this.CreditCardService = CreditCardService;
            this.SettingsService = SettingsService;
            this.AddressService = AddressService;
            this.AddressListService = AddressListService;
            this.searchTerm = '';
            this.sortDays = 0;
            this.CommonDataService = CommonDataService;
            this.ProductService = ProductService;
            this.$window = $window;
            this.$location = $location;
            this.$anchorScroll = $anchorScroll;
            this.$timeout = $timeout;
            this.cache = $cacheFactory.get(this.scrollPageCacheTag) || $cacheFactory(this.scrollPageCacheTag);
            this.seoMetaService = seoMetaService;
            this.seoMetaService.updateSeoMetaData(this, 'ReorderProductsListComponent');
            var pageSettings = this.cache.get(this.pageSettingsCacheKey);
            this.orderPageModel = {
                currentPage: 1,
                pageSize: 25,
                totalPages: 1,
                pages: [1]
            };
            if (pageSettings) {
                this.isSettingsLoadedFromCache = true;
                if (pageSettings.currentPage) {
                    this.orderPageModel.currentPage = pageSettings.currentPage;
                }
                if (pageSettings.pageSize) {
                    this.orderPageModel.pageSize = pageSettings.pageSize;
                }
                if (pageSettings.sortType) {
                    this.sortType = pageSettings.sortType;
                }
                if (pageSettings.sortReverse) {
                    this.sortReverse = pageSettings.sortReverse;
                }
                if (pageSettings.searchTerm) {
                    this.searchTerm = pageSettings.searchTerm;
                }
                if (pageSettings.sortDays) {
                    this.sortDays = pageSettings.sortDays;
                }
            }
            self.Auth.isLoggedIn(function (loggedInUser) {
                if (loggedInUser) {
                    self.loggedInUser = loggedInUser;
                    self.getAccountData();
                }
            });
            this.addToCartErrorDialog = {
                template: "\n        <md-dialog class=\"cart-summary-dialog\">\n          <cart-summary-dialog response=\"addToCartResponse\"></cart-summary-dialog>\n        </md-dialog>\n      ",
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose: true,
                escapeToClose: true,
                fullscreen: false
            };
            this.alternateSizesDialog = {
                template: "\n        <md-dialog class=\"alternate-sizes-dialog\">\n          <alternate-sizes-dialog\n            base-product=\"selectedProduct\"\n            alternates=\"productAlternativeSizes\"></alternate-sizes-dialog>\n        </md-dialog>\n        ",
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose: true,
                escapeToClose: true,
                fullscreen: false
            };
        }
        ReorderProductsListComponent.prototype.filterByLastNDays = function (sortDays) {
            var _this = this;
            if ((sessionStorage.getItem('isHistoryEvent') === 'true') && (sessionStorage.getItem('reorderPageNo') && sessionStorage.getItem('reorderSortDays'))) {
                this.orderPageModel.currentPage = sessionStorage.getItem('reorderPageNo');
            }
            else {
                this.sortDays = sortDays;
                this.orderPageModel.currentPage = 1;
                sessionStorage.setItem('reorderSortDays', this.sortDays);
            }
            this.reorderProductsService
                .getReorderProducts(this.orderPageModel.currentPage, this.orderPageModel.pageSize, this.sortType, this.sortReverse, this.searchTerm, sortDays)
                .then(function (response) {
                if (response) {
                    _this.loadProducts(response, false);
                }
                else {
                    _this.products = [];
                    _this.updateOrderPageModel({ totalResults: 0 });
                }
            });
        };
        ReorderProductsListComponent.prototype.bannerMessage = function (message) {
            this.errors.pageErrorType = 'api';
            this.errors.pageErrors = message;
            this.errors.havePageErrors = true;
        };
        ReorderProductsListComponent.prototype.decideWhereToGo = function () {
            var goto = 'reviewOrder';
            this.CartService.setLinkStatus(goto);
            if (this.shippingOptionsProblem()) {
                goto = 'shippingAndDelivery';
                this.CartService.setLinkStatus(goto);
            }
            else if (this.paymentOptionsProblem()) {
                goto = 'payment';
                this.CartService.setLinkStatus(goto);
            }
            return goto;
        };
        ReorderProductsListComponent.prototype.shippingOptionsProblem = function () {
            var isInternational;
            if (this.cart) {
                // check if address is international
                if (this.cart.shippingAddress) {
                    isInternational = this.cart.shippingAddress.countryCode !== "US";
                }
            }
            return (isInternational ||
                !this.defaultAddress ||
                !this.defaultShipMethod ||
                this.hasItemLevelShippingIssue);
        };
        ReorderProductsListComponent.prototype.paymentOptionsProblem = function () {
            var cardExpired = false;
            if (this.defaultPayment && this.defaultPayment.paymentType === "CreditCard") {
                // check if card is expired
                var today = new Date();
                var expDate = new Date();
                var dateStr = this.defaultPayment.expirationDate;
                expDate.setDate(1);
                expDate.setMonth(dateStr.split('/')[1] - 1);
                expDate.setFullYear(dateStr.split('/')[0]);
                cardExpired = (today > expDate);
            }
            return (cardExpired || !this.defaultPayment);
        };
        ReorderProductsListComponent.prototype.addToCart = function (item, quantity) {
            var _this = this;
            if (!quantity)
                return false;
            this.$rootScope.loading = true;
            this.CartService.addItemQuantity(item.itemCode, quantity)
                .then(function (data) {
                item['addedSuccessfully'] = true;
            })
                .catch(function (reason) {
                _this.$scope.addToCartResponse = { error: true, reason: reason };
                _this.$mdDialog.show(_this.addToCartErrorDialog);
            })
                .finally(function () {
                _this.$rootScope.loading = false;
            });
        };
        ReorderProductsListComponent.prototype.itemLevelShippingChecks = function (code) {
            return (code === this.errorCodes.heatSensitive ||
                code === this.errorCodes.heatSensitiveFrozen ||
                code === this.errorCodes.manufacturerRestriction);
        };
        ReorderProductsListComponent.prototype.clearQuantity = function (itemCode) {
            this.products.forEach(function (product) {
                if (product.itemCode == itemCode) {
                    product.newQuantityToOrder = '';
                }
            });
        };
        ReorderProductsListComponent.prototype.decrement = function (id) {
            var index = this.products.findIndex(function (product) { return product.itemCode == id; });
            var orderQuantity = parseInt(this.products[index].newQuantityToOrder);
            if (orderQuantity - 1 === 0) {
                this.products[index].newQuantityToOrder = 0;
            }
            if (orderQuantity - 1 > 0) {
                this.products[index].newQuantityToOrder = orderQuantity - 1;
            }
        };
        ReorderProductsListComponent.prototype.increment = function (id) {
            var index = this.products.findIndex(function (product) { return product.itemCode == id; });
            var orderQuantity = parseInt(this.products[index].newQuantityToOrder);
            var isValidated = this.isValidReorderProduct(index);
            if (!isValidated) {
                return false;
            }
            this.products[index].newQuantityToOrder = orderQuantity + 1;
            this.products[index].total = this.products[index].quantityOrdered * this.products[index].price;
        };
        ReorderProductsListComponent.prototype.updateDisplay = function (data) {
            this.customerId = data.customerId;
            this.defaultAddress = data.defaultShippingAddress;
            this.selectedAddress = data.defaultShippingAddress;
            this.defaultPayment = data.defaultPayment;
            this.defaultShipMethod = null;
            this.CartService.setNewDeliveryMethod(this);
            this.CartService.expressCheckoutContext = {
                shippingAddress: this.defaultAddress,
                shipVia: this.defaultShipMethod,
                payment: this.defaultPayment
            };
            this.selectedPayment = data.defaultPayment;
        };
        ;
        ReorderProductsListComponent.prototype.getReorderProductsList = function () {
            var _this = this;
            if (!this.isSettingsLoadedFromCache) {
                if ((sessionStorage.getItem('isHistoryEvent') === 'true') && sessionStorage.getItem('reorderPageNo')) {
                    this.orderPageModel.currentPage = sessionStorage.getItem('reorderPageNo');
                }
                else {
                    this.orderPageModel.currentPage = 1;
                }
            }
            else {
                this.isSettingsLoadedFromCache = false;
            }
            this.reorderProductsService.getReorderProducts(this.orderPageModel.currentPage, this.orderPageModel.pageSize, this.sortType, this.sortReverse, this.searchTerm)
                .then(function (response) {
                if (response) {
                    _this.loadProducts(response, true);
                }
                else {
                    _this.products = [];
                    _this.updateOrderPageModel({ totalResults: 0 });
                }
            });
        };
        /**
         * mark items in cart as added
         */
        ReorderProductsListComponent.prototype.markItemsInCartAsAdded = function () {
            var _this = this;
            this.CartService._getCart(true).then(function (response) {
                if (response &&
                    response.data &&
                    response.data.response &&
                    response.data.response.aresLineItems) {
                    for (var reorderKey in _this.products) {
                        for (var cartKey in response.data.response.aresLineItems) {
                            if (_this.products[reorderKey].itemCode === response.data.response.aresLineItems[cartKey].itemId) {
                                _this.products[reorderKey].addedSuccessfully =
                                    (response.data.response.aresLineItems[cartKey].quantity > 0);
                            }
                        }
                    }
                }
            });
        };
        ReorderProductsListComponent.prototype.getAccountData = function () {
            var _this = this;
            var self = this;
            this.CartService.subscribe(this.$scope, function (event, cart) {
                self.cart = cart;
                if (cart.aresLineItems) {
                    self.hasItemLevelShippingIssue = _this.CartService.hasItemLevelShippingProblem(cart);
                }
            });
            // GET all user's information
            self.$q.all([
                self.AddressService.getAddresses(),
                self.CreditCardService.getCreditCards(),
                self.SettingsService.getAccount()
            ])
                .then(function (responses) { return self.handleAccountData(self, responses); });
        };
        ReorderProductsListComponent.prototype.handleAccountData = function (self, responses) {
            responses.forEach(function (response) {
                if (response.status !== undefined && response.status !== null && response.status !== 200) {
                    self.bannerMessage("We're sorry, there's some kind of technical problem with our website right now. Please try again later.");
                }
            });
            // Addresses responses[0]
            if (responses[0] !== null && typeof (responses[0]) === 'object') {
                self.addresses = responses[0].data.response.currentPage;
                self.hasAddresses = (self.addresses !== null && typeof (self.addresses) === 'object');
            }
            // paymentMethods
            self.paymentMethods = responses[1];
            self.hasPaymentMethods = (self.paymentMethods !== null && typeof (self.paymentMethods) === 'object');
            if (self.hasPaymentMethods) {
                self.paymentMethods.forEach(function (method, index, methods) {
                    var paymentType = methods[index].paymentType;
                    if (!method.cardNickName) {
                        methods[index].cardNickName = method.nameOnCard;
                    }
                    if (paymentType === 'Terms' ||
                        paymentType === 'COD' ||
                        paymentType === 'Prepaid') {
                        methods[index].cardNickName = method.paymentType;
                        methods[index].creditCardId = method.paymentType;
                    }
                });
            }
            // Account responses[2]
            if (responses[2]) {
                self.account = responses[2];
                self.blockCheckOut = self.account.blockCheckOut;
            }
            self.hasAccountData = (self.account !== null && typeof (self.account) === 'object');
            if (self.hasAccountData) {
                self.updateDisplay(self.account);
            }
        };
        ReorderProductsListComponent.prototype.isValidReorderProduct = function (index) {
            var isDiscontinued = this.products[index].isDiscontinued;
            var isVendorBackOrder = this.products[index].isVendorBackOrder;
            var availableQuantity = this.products[index].quantity;
            if ((isDiscontinued || isVendorBackOrder) && availableQuantity <= 0) {
                this.products[index].newQuantityToOrder = 0;
                return false;
            }
            return true;
        };
        ReorderProductsListComponent.prototype.$onInit = function () {
            if ((sessionStorage.getItem('isHistoryEvent') !== 'true') || (sessionStorage.getItem('reorderPageNo') && !(sessionStorage.getItem('reorderSortDays')))) {
                this.getReorderProductsList();
            }
            else {
                this.sortDays = sessionStorage.getItem('reorderSortDays');
            }
        };
        ReorderProductsListComponent.prototype.orderPageChanged = function () {
            var _this = this;
            this.reorderProductsService.getReorderProducts(this.orderPageModel.currentPage, this.orderPageModel.pageSize, this.sortType, this.sortReverse, this.searchTerm, this.sortDays)
                .then(function (response) {
                _this.loadProducts(response, true);
            });
            this.scrollToContainerTop();
        };
        ReorderProductsListComponent.prototype.scrollToContainerTop = function () {
            this.$location.hash('scroll-to-tag');
            this.$anchorScroll();
        };
        ReorderProductsListComponent.prototype.updateOrderPageModel = function (response) {
            this.orderPageModel.totalPages = Math.ceil(response.totalResults / this.orderPageModel.pageSize);
            this.orderPageModel.pages = Array.from({ length: this.orderPageModel.totalPages }, function (x, i) { return i + 1; });
            this.orderPageModel.currentPage = response.pageNumber;
            if (sessionStorage.getItem('isHistoryEvent') === 'true') {
                sessionStorage.setItem('isHistoryEvent', false);
            }
        };
        ReorderProductsListComponent.prototype.queryOrder = function () {
            var _this = this;
            this.orderPageModel.currentPage = 1;
            this.reorderProductsService
                .getReorderProducts(this.orderPageModel.currentPage, this.orderPageModel.pageSize, this.sortType, this.sortReverse, this.searchTerm, this.sortDays)
                .then(function (response) {
                _this.loadProducts(response, true);
            });
        };
        ReorderProductsListComponent.prototype.searchOrder = function () {
            var _this = this;
            this.orderPageModel.currentPage = 1;
            this.sortDays = 0;
            this.reorderProductsService
                .getReorderProducts(this.orderPageModel.currentPage, this.orderPageModel.pageSize, this.sortType, this.sortReverse, this.searchTerm, this.sortDays)
                .then(function (response) {
                _this.loadProducts(response, true);
            });
        };
        ReorderProductsListComponent.prototype.loadProducts = function (response, isOriginalProductsSaved) {
            if (isOriginalProductsSaved === void 0) { isOriginalProductsSaved = true; }
            this.products = response.currentPage;
            this.CommonDataService.addAttributeProductPathsForAllItems(this.products);
            this.updateOrderPageModel(response);
            if (isOriginalProductsSaved) {
                this.originalProducts = this.products;
            }
            // newQuantityToOrder will hold the quantity that user specifies using "- and +" widget on the UI.
            for (var key in this.products) {
                this.products[key].newQuantityToOrder = 1;
                this.products[key].showButtons = false;
            }
            this.markItemsInCartAsAdded();
            this.viewAlternatesCheck();
            this.$timeout(this.goToCacheScrollPosition, 500, false, this);
        };
        ReorderProductsListComponent.prototype.viewAlternatesCheck = function () {
            var _this = this;
            this.alternateSizes = [];
            var _loop_1 = function (productKey) {
                if (this_1.products[productKey].isVendorBackOrder && this_1.products[productKey].quantity <= 0) {
                    this_1.ProductService.getProductDetails(this_1.products[productKey].productId)
                        .then(function (productModel) {
                        _this.initializeAlternatives(productModel, productKey);
                    });
                }
                else {
                    this_1.products[productKey].showButtons = true;
                }
            };
            var this_1 = this;
            for (var productKey in this.products) {
                _loop_1(productKey);
            }
        };
        ReorderProductsListComponent.prototype.initializeAlternatives = function (productModel, productKey) {
            var _this = this;
            var availableItems = [];
            this.products[productKey].isAlternateSizeAvailable = false;
            this.products[productKey].isAlternateProductAvailable = false;
            for (var itemKey in productModel.items) {
                if (!productModel.items[itemKey].isDiscontinued &&
                    this.isItemWithInventory(productModel.items[itemKey]) &&
                    this.products[productKey].itemCode !== productModel.items[itemKey].itemCode) {
                    this.products[productKey].isAlternateSizeAvailable = true;
                    availableItems.push(productModel.items[itemKey]);
                }
            }
            if (!this.products[productKey].isAlternateSizeAvailable) {
                this.ProductService.getAlternateProductsDetails(this.products[productKey].productId)
                    .then(function (response) {
                    if (!!response && !!response[0]) {
                        var alternateProducts = response.filter(function (product) { return product.items.some(function (item) { return !item.isRestricted &&
                            item.inventory.some(function (i) { return i.stock > 0 && i.isDefault; }); }); });
                        if (!!alternateProducts.length) {
                            _this.products[productKey].isAlternateProductAvailable = true;
                        }
                    }
                    _this.products[productKey].showButtons = true;
                });
            }
            else {
                productModel.items = availableItems;
                this.alternateSizes[this.products[productKey].productId] = productModel;
                this.products[productKey].showButtons = true;
            }
        };
        ReorderProductsListComponent.prototype.isItemWithInventory = function (item) {
            for (var inventoryKey in item.inventory) {
                if (item.inventory[inventoryKey].stock > 0) {
                    return true;
                }
            }
            return false;
        };
        ReorderProductsListComponent.prototype.reorderCurrentPage = function (pageNumber) {
            sessionStorage.setItem('reorderPageNo', pageNumber);
        };
        ReorderProductsListComponent.prototype.showAlternateSizes = function (product) {
            this.$scope.selectedProduct = product;
            this.$scope.productAlternativeSizes = this.alternateSizes[product.productId];
            this.$mdDialog.show(this.alternateSizesDialog);
            this.ga.sendEvent('EE Product Alternates', 'click', 'View Alternate Sizes button', 1);
        };
        ReorderProductsListComponent.prototype.showAlternateProducts = function (product) {
            this.ga.sendEvent('EE Product Alternates', 'click', 'View Similar Products button on reorder page', 1);
            // go to that product page's "YOU MAY ALSO LIKE" section
            this.cacheScrollPosition();
            this.ProductService.gotoAlternateProduct = true;
            this.$location.path("/products/detail/" +
                product.attributeNamePath + "/" +
                product.productNamePath + "/" +
                product.productId + "/" +
                product.itemCode);
        };
        ReorderProductsListComponent.prototype.cacheScrollPosition = function () {
            var scrollPosition = {
                x: this.$window.pageXOffset,
                y: this.$window.pageYOffset
            };
            var pageSettings = {
                currentPage: this.orderPageModel.currentPage,
                pageSize: this.orderPageModel.pageSize,
                sortType: this.sortType,
                sortReverse: this.sortReverse,
                searchTerm: this.searchTerm,
                sortDays: this.sortDays
            };
            this.cache.put(this.pageSettingsCacheKey, pageSettings);
            this.cache.put(this.scrollPositionCacheKey, scrollPosition);
        };
        ReorderProductsListComponent.prototype.goToCacheScrollPosition = function (self) {
            var scrollPosition = self.cache.get(self.scrollPositionCacheKey);
            if (scrollPosition) {
                self.$window.scrollTo(scrollPosition.x, scrollPosition.y);
            }
        };
        return ReorderProductsListComponent;
    }())
};
//# sourceMappingURL=reorder-products-list.component.js.map